import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { CompanyBetaProgramsTabGzDataProvider } from '../dataProvider/CompanyBetaProgramsTabGzDataProvider';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class CompanyBetaProgramsTabDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CompanyBetaProgramsTabGzDataProvider);
  }
}
